module.exports = __webpack_public_path__ + "img/default-user.2abba707.png";